import React from 'react';

interface ToggleProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  onDisabledClick?: () => void;
  className?: string;
  icon?: React.ReactNode;
  labelClassName?: string;
  newBadge?: React.ReactNode;
}

const Toggle: React.FC<ToggleProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  onDisabledClick,
  className = '',
  icon,
  labelClassName = '',
  newBadge,
}) => {
  const showPaywallOverlay = disabled && onDisabledClick;
  const handleOverlayKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onDisabledClick?.();
    }
  };
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <label htmlFor={id} className={`text-sm font-medium text-gray-700 flex items-center ${labelClassName}`}>
        {icon && <span className="mr-2 flex-shrink-0">{icon}</span>}
        <span>{label}</span>
        {newBadge && <span className="ml-2 flex-shrink-0">{newBadge}</span>}
      </label>
      <div className="relative flex-shrink-0">
        <button
          type="button"
          role="switch"
          aria-checked={checked}
          disabled={disabled}
          onClick={() => !disabled && onChange(!checked)}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
            ${checked 
              ? 'bg-primary' 
              : 'bg-gray-200'
            }
            ${disabled 
              ? 'opacity-50 cursor-not-allowed' 
              : 'cursor-pointer'
            }
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out
              ${checked ? 'translate-x-6' : 'translate-x-1'}
            `}
          />
        </button>
        {showPaywallOverlay && (
          <div
            role="button"
            tabIndex={0}
            className="absolute inset-0 cursor-pointer rounded-full"
            onClick={onDisabledClick}
            onKeyDown={handleOverlayKeyDown}
            aria-label="Upgrade to enable"
          />
        )}
      </div>
    </div>
  );
};

export default Toggle;
